import React, { FC, useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, message } from 'antd';
import ProjectTemplateForm from '../project_template_form/ProjectTemplateForm';
import { EditPage } from '../edit_page/EditPage';
import {
	projectTemplatesRestCrudThunksForBuyer,
	projectTemplatesRestCrudThunksForSupplier,
} from '../../thunks/project_template_thunks';
import { getProjectTemplateCopy } from '../../utils/ProjectTemplateUtils';
import { getLocationSearch } from '../../utils/HistoryUtils';
import { withUserType } from '../withUserType';
import { ROLE_TYPES } from '../../utils/DataConstants';

const { Content } = Layout;
const queryString = require('qs');

// Also the landing page for "Copy and create new" from a template's detail page —
// same flow as NewAssetPage: ?copyFromProjectTemplateId=<id> seeds the form with a
// stripped copy of that template (fields, deliverables and tasks included).
const NewProjectTemplatePage: FC<any> = ({
	history,
	location,
	userType,
	getProjectTemplate,
}): React.ReactElement => {
	const [fetching, setFetching] = useState(false);
	const [formData, setFormData] = useState({});

	const copyProjectTemplate = useCallback(
		(id) => {
			setFetching(true);
			getProjectTemplate(userType, id)
				.then((projectTemplate) => setFormData(getProjectTemplateCopy(projectTemplate)))
				.catch((err) => message.error(err))
				.finally(() => setFetching(false));
		},
		[getProjectTemplate, userType]
	);

	useEffect(() => {
		const queryParams = queryString.parse(getLocationSearch(location));
		queryParams.copyFromProjectTemplateId &&
			copyProjectTemplate(queryParams.copyFromProjectTemplateId);
	}, [copyProjectTemplate, location]);

	return (
		<Content>
			<EditPage
				title="New Project Template"
				formComponentProps={{
					formData,
					onSuccess: (rec) => history.push(`/${userType}/projects/templates/detail/${rec.id}`),
				}}
				fetching={fetching}
				FormComponent={ProjectTemplateForm}
			/>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({
	getProjectTemplate: (userType, id) =>
		dispatch(
			userType === ROLE_TYPES.SUPPLIER
				? projectTemplatesRestCrudThunksForSupplier.readOne(id)
				: projectTemplatesRestCrudThunksForBuyer.readOne(id)
		),
});

export default withUserType(
	withRouter(connect(mapStateToProps, mapDispatchToProps)(NewProjectTemplatePage))
);
